import styled from 'styled-components';

export const SocialList = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 1.6rem;
  margin: 0;
`;
